/**
 * @file The 404 page, rendered inside the app shell (header kept) for any URL no route matches.
 *
 * Signed out, AppShell shows the sign-in screen for every path but the reset page, so this is only
 * ever seen signed in. It names no ids and discloses nothing about what exists.
 */
import { Link } from "@tanstack/react-router";
import { Card } from "./ui";

export function NotFound() {
  return (
    <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-8">
      <Card className="items-start gap-3 px-6 py-8">
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="text-sm text-muted-foreground">
          That page doesn&rsquo;t exist, or the link is out of date.
        </p>
        <Link
          to="/"
          className="inline-flex h-11 items-center rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Back to dashboard
        </Link>
      </Card>
    </main>
  );
}
